export const types = {
  set: 'SET_AUTH',
  unset: 'UNSET_AUTH'
} as const

export function setAuth(
  id: number,
  token: string,
  adminId: string,
  password: string,
  name: string
) {
  return { type: types.set, payload: { id, token, adminId, password, name } }
}
export function unsetAuth() {
  return { type: types.unset }
}
